export enum IUserOfficeStatus {
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    INVITATION = 'INVITATION',
    REJECTED = 'REJECTED',
    REMOVED = 'REMOVED',
    ACTIVE = 'ACTIVE'
}